<template>
  <div v-show="dataLoaded">
    <el-scrollbar height="100%" class="ShowCreateMelkUser">
      <div class="createContract">
        <!-- <div class="createContractTitleWrapper">
          <div class="contractTitleContainer">
            <h1 class="contractTitle">ثبت قرارداد</h1>

            <div v-if="clickFalse" @click="closeBtnPush" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left"></i>
            </div>

            <div v-if="!clickFalse" @click="closeBtn" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left"></i>
            </div>
          </div>
        </div> -->
        <div class="createMelkHeader">
          <div class="createMelkHeaderContainer">
            <div class="createMelkHeaderTitle">
              <h1>ویرایش قرارداد</h1>
            </div>
            <div v-if="clickFalse" @click="closeBtnPush" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left" style="font-size: 24px"></i>
            </div>

            <div v-if="!clickFalse" @click="closeBtn" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left" style="font-size: 24px"></i>
            </div>
          </div>
        </div>
        <div class="createContractFormOuter">
          <div class="formTabToggle">
            <div
              class="tabToggleContainer"
              :class="[form.cat_id == 2 ? 'lease' : 'allegiance']"
            >
              <div class="switchBtn"></div>
              <div
                class="tabToggleBtn"
                :class="{ active: form.cat_id == 2 }"
                @click="form.cat_id = 2"
              >
                اجاره نامه
                <i class="fas fa-signature"></i>
              </div>
              <div
                class="tabToggleBtn"
                :class="{ active: form.cat_id === 1 }"
                @click="form.cat_id = 1"
              >
                مبایعه نامه
                <i class="fas fa-hand-holding-usd"></i>
              </div>
            </div>
          </div>
          <div>
            <form action="" class="createContractForm">
              <div class="createContractFormContainer">
                <div class="createContractFormRow">
                  <div
                    class="createContractFormGroup oneHalfGroup"
                    :class="{
                      focus: isFocus === 'title',
                      done: form.title !== '',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span class="text-danger">*</span>
                      عنوان
                    </label>
                    <input
                      type="text"
                      maxlength="40"
                      v-model="form.title"
                      class="formGroupInput"
                      placeholder=""
                      @focus="inputFocusHanlder('title')"
                      @blur="inputFocusHanlder('')"
                    />
                  </div>
                  <div
                    class="createContractFormGroup oneFourthGroup"
                    :class="{
                      focus: isFocus === 'contract_date',
                      done: form.contract_date !== '',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span class="text-danger">*</span>تاریخ </label
                    ><input
                      data-jdp
                      class="formGroupInput"
                      v-model="form.contract_date"
                      @focus="inputFocusHanlder('contract_date')"
                      @blur="inputFocusHanlder('')"
                    />
                    <!-- <DatePicker
                    clearable
                    v-model="form.contract_date"
                    mode="single"
                    :column="1"
                    input-format="jYYYY-jMM-jDD"
                    format="YYYY-MM-DD"
                    class="formGroupInput"
                    @focus="inputFocusHanlder('contract_date')"
                    @blur="inputFocusHanlder('')"
                  /> -->
                  </div>
                  <div
                    class="createContractFormGroup oneFourthGroup"
                    :class="{
                      focus: isFocus === 'contract_number',
                      done: form.contract_number !== '',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span class="text-danger">*</span>شماره قرارداد
                    </label>
                    <input
                      type="text"
                      maxlength="60"
                      v-model="form.contract_number"
                      class="formGroupInput text-left"
                      inputmode="numeric"
                      placeholder=""
                      @focus="inputFocusHanlder('contract_number')"
                      @blur="inputFocusHanlder('')"
                    />
                  </div>
                </div>
                <div class="createContractFormRow">
                  <div
                    class="createContractFormGroup oneThirdGroup"
                    :class="{
                      focus: isFocus === 'consultant_id',
                      done: form.consultant_id !== '0',
                    }"
                  >
                    <label class="formGroupLabel">
                      <!--                    <span class="text-danger">*</span>-->
                      انتخاب کارمند
                    </label>
                    <el-select
                      filterable
                      class="formGroupSelect"
                      v-model="form.consultant_id"
                      placeholder=""
                      @focus="inputFocusHanlder('consultant_id')"
                      @blur="inputFocusHanlder('')"
                    >
                      <el-option
                        v-for="(item, i) in consultant_list"
                        :key="i"
                        :label="item.nickname"
                        :value="item.uid"
                      />
                    </el-select>
                  </div>
                  <div
                    class="createContractFormGroup oneThirdGroup"
                    :class="{
                      focus: isFocus === 'first_user_commission',
                      done: form.first_user_commission !== '',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span v-if="form.cat_id == 2">کمیسیون موجر</span>
                      <span v-if="form.cat_id == 1">کمیسیون خریدار</span>
                    </label>
                    <input
                      type="text"
                      maxlength="60"
                      @input="
                        (event) =>
                          setformatPrice(event, 'first_user_commission')
                      "
                      inputmode="numeric"
                      v-model="front_show.first_user_commission"
                      class="formGroupInput text-left"
                      placeholder=""
                      @focus="inputFocusHanlder('first_user_commission')"
                      @blur="inputFocusHanlder('')"
                    />
                  </div>
                  <div
                    class="createContractFormGroup oneThirdGroup"
                    :class="{
                      focus: isFocus === 'second_user_commission',
                      done: form.second_user_commission !== '',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span v-if="form.cat_id == 2">کمیسیون مستاجر</span>
                      <span v-if="form.cat_id == 1">کمیسیون فروشنده</span>
                    </label>
                    <input
                      type="text"
                      maxlength="60"
                      @input="
                        (event) =>
                          setformatPrice(event, 'second_user_commission')
                      "
                      inputmode="numeric"
                      v-model="front_show.second_user_commission"
                      class="formGroupInput text-left"
                      placeholder=""
                      @focus="inputFocusHanlder('second_user_commission')"
                      @blur="inputFocusHanlder('')"
                    />
                  </div>
                </div>
                <div class="createContractFormRow">
                  <div
                    class="createContractFormGroup oneHalfGroup"
                    :class="{
                      focus: isFocus === 'first_users',
                      done: form.first_users !== '0',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span v-if="form.cat_id == 2"
                        ><span class="text-danger">*</span>مشخصات موجر</span
                      >
                      <span v-if="form.cat_id == 1"
                        ><span class="text-danger">*</span>مشخصات خریدار</span
                      >
                    </label>
                    <input
                      type="text"
                      v-model="form.first_users"
                      class="formGroupInput"
                      placeholder=""
                      @focus="inputFocusHanlder('first_users')"
                      @blur="inputFocusHanlder('')"
                    />
                  </div>
                  <div
                    class="createContractFormGroup oneHalfGroup"
                    :class="{
                      focus: isFocus === 'second_users',
                      done: form.second_users !== '0',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span v-if="form.cat_id == 2"
                        ><span class="text-danger">*</span>مشخصات مستاجر</span
                      >
                      <span v-if="form.cat_id == 1"
                        ><span class="text-danger">*</span>مشخصات فروشنده</span
                      >
                    </label>
                    <input
                      type="text"
                      v-model="form.second_users"
                      class="formGroupInput"
                      placeholder=""
                      @focus="inputFocusHanlder('second_users')"
                      @blur="inputFocusHanlder('')"
                    />
                  </div>
                </div>
                <div class="createContractFormRow">
                  <div
                    class="createContractFormGroup fullGroup"
                    :class="{
                      focus: isFocus === 'description',
                      done: form.description !== '',
                    }"
                  >
                    <label class="textareaLabel">
                      <span class="text-danger"></span>توضیحات
                    </label>
                    <textarea
                      type="text"
                      maxlength="300"
                      v-model="form.description"
                      class="formGroupTextarea"
                      placeholder=""
                      rows="4"
                      @focus="inputFocusHanlder('description')"
                      @blur="inputFocusHanlder('')"
                    ></textarea>
                  </div>
                </div>
                <div class="createContractFormRow">
                  <!-- <div
                  class="createContractFormGroup oneFourthGroup"
                  :class="{
                    focus: isFocus === 'type',
                    done: form.type !== '',
                  }"
                >
                  <label class="formGroupLabel">
                    <span class="text-danger">*</span>نوع قرارداد</label
                  >
                  <el-select
                    v-model="form.type"
                    class="formGroupSelect"
                    @focus="inputFocusHanlder('type')"
                    @blur="inputFocusHanlder('')"
                  >
                    <el-option value="0">مبایعه نامه</el-option>
                    <el-option value="1" selected>اجاره نامه</el-option>
                  </el-select>
                </div> -->
                  <div
                    v-if="form.cat_id == 1"
                    class="createContractFormGroup oneSixthGroup"
                    :class="{
                      focus: isFocus === 'amount',
                      done: form.amount !== '',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span class="text-danger"></span>مبلغ قرارداد
                    </label>
                    <input
                      type="text"
                      maxlength="60"
                      @input="(event) => setformatPrice(event, 'amount')"
                      inputmode="numeric"
                      v-model="front_show.amount"
                      class="formGroupInput text-left"
                      placeholder=""
                      @focus="inputFocusHanlder('amount')"
                      @blur="inputFocusHanlder('')"
                    />
                  </div>
                  <div
                    v-if="form.cat_id == 2"
                    class="createContractFormGroup oneSixthGroup"
                    :class="{
                      focus: isFocus === 'mortgage_price',
                      done: form.mortgage_price !== '',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span class="text-danger"></span>مبلغ رهن</label
                    >
                    <input
                      type="text"
                      maxlength="60"
                      @input="
                        (event) => setformatPrice(event, 'mortgage_price')
                      "
                      inputmode="numeric"
                      v-model="front_show.mortgage_price"
                      class="formGroupInput text-left"
                      placeholder=""
                      @focus="inputFocusHanlder('mortgage_price')"
                      @blur="inputFocusHanlder('')"
                    />
                  </div>
                  <div
                    v-if="form.cat_id == 2"
                    class="createContractFormGroup oneSixthGroup"
                    :class="{
                      focus: isFocus === 'rent_price',
                      done: form.rent_price !== '',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span class="text-danger"></span>مبلغ اجاره</label
                    >
                    <input
                      type="text"
                      maxlength="60"
                      @input="(event) => setformatPrice(event, 'rent_price')"
                      inputmode="numeric"
                      v-model="front_show.rent_price"
                      class="formGroupInput text-left"
                      placeholder=""
                      @focus="inputFocusHanlder('rent_price')"
                      @blur="inputFocusHanlder('')"
                    />
                  </div>
                  <div
                    v-if="form.cat_id == 2"
                    class="createContractFormGroup oneSixthGroup"
                    :class="{
                      focus: isFocus === 'end_date',
                      done: form.end_date !== '',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span class="text-danger"></span>تاریخ سررسید</label
                    >
                    <input
                      class="formGroupInput"
                      data-jdp
                      v-model="form.end_date"
                      @focus="inputFocusHanlder('end_date')"
                      @blur="inputFocusHanlder('')"
                    />
                    <!-- <DatePicker
                    v-model="form.end_date"
                    mode="single"
                    :column="1"
                    input-format="jYYYY-jMM-jDD"
                    format="YYYY-MM-DD"
                    class="formGroupInput"
                    @focus="inputFocusHanlder('end_date')"
                    @blur="inputFocusHanlder('')"
                  /> -->
                  </div>
                  <div
                    class="createContractFormGroup oneLessHalfGroup"
                    :class="{
                      focus: isFocus === 'post_id',
                      done: form.post_id !== '',
                    }"
                  >
                    <label class="formGroupLabel">
                      <span class="text-danger">*</span>انتخاب فایل</label
                    >
                    <el-select
                      filterable
                      class="formGroupSelect"
                      v-model="form.post_id"
                      @focus="inputFocusHanlder('post_id')"
                      @blur="inputFocusHanlder('')"
                      placeholder=""
                    >
                      <!--                     <el-option value="0">انتخاب کنید</el-option> -->
                      <el-option
                        v-for="(v, i) in post_list"
                        :key="i"
                        :value="v.id"
                        :label="v.content"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </form>
            <div class="formButtonContainer">
              <button
                type="submit"
                class="formSubmitBtn closeBtn"
                @click="closeBtn"
              >
                <i class="fas fa-arrow-right"></i>
                برگشت
              </button>
              <button
                v-if="!btnLoading"
                @click="save()"
                type="submit"
                class="formSubmitBtn"
              >
                ویرایش قرارداد
                <i class="fas fa-check"></i>
              </button>
              <button v-if="btnLoading" type="submit" class="formSubmitBtn">
                <span class="loader"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
// import DatePicker from "@alireza-ab/vue3-persian-datepicker";
// import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
// import { toast } from "vue3-toastify";
import "@majidh1/jalalidatepicker/dist/jalalidatepicker.min.css";
import "@majidh1/jalalidatepicker";
import { toast } from "vue3-toastify";

export default {
  name: "editContract",
  props: {
    contractId: String,
    BranchInfos: Object,
    noteBookContract: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    // DatePicker,
  },
  data() {
    return {
      isFocus: "",
      btnLoading: false,
      isDarkMode: false,
      clickFalse: false,
      editIndex: null,
      form: {
        cat_id: 2,
        title: "",
        post_id: "",
        first_user_commission: "",
        second_user_commission: "",
        contract_date: "",
        contract_number: "",
        amount: "",
        consultant_id: "0",

        first_users: "0",
        second_users: "0",
        description: "",
        mortgage_price: "",
        rent_price: "",
        end_date: "",
      },
      front_show: {
        contract_number: "",
        amount: "",
        mortgage_price: "",
        rent_price: "",
        first_user_commission: "",
        second_user_commission: "",
      },
      editorConfig: {
        contentsLangDirection: "rtl",
        extraPlugins: "justify,colorbutton,font,bidi,image,link",
        toolbar: [
          ["Bold", "Italic", "Underline", "Strike"],
          ["Font", "FontSize"],
          ["TextColor", "BGColor"],
          ["JustifyRight", "JustifyCenter", "JustifyLeft", "JustifyBlock"],
          ["BidiLtr", "BidiRtl"],
          ["Link", "Unlink"],
          ["Image", "Media"],
          ["Undo", "Redo"],
        ],
      },
      fillter: {
        main_category: "all",
        category: "all", //commercial
        text: "",
        location: "",
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        bed: -1,
        min_age: 0,
        max_age: 0,
        min_floor: "0",
        max_floor: "0",
        min_totalFloor: "0",
        max_totalFloor: "0",
        min_Floorunit: "0",
        max_Floorunit: "0",
        docType: "0",
        // parking: false,
        // storage: false,
        // elevator: false,
        // photo: false,
        // newProperty: false,
        // special: false,
        advertiser: "all",
        district: "0",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        city: 0,
        m_id: 0,
        per_page: 'get',
        date: "",
        role: "branch_admin",
        consultant: 0,
        status: "approved",
        list_type: "own_profile",
      },
      post_list: [],
      consultant_list: [],
      users_list: [],
      dataLoaded: false,
    };
  },
  mounted() {
    this.load_post();
    this.load_consultant();
    this.load_users();
    this.load_contractInfo();
    document.body.style = "overflow: hidden;";
    window.jalaliDatepicker.startWatch({});
    // this.get_state();
  },
  methods: {
    load_contractInfo() {
      console.log("this.contractId", this.contractId);
      let self = this;
      self
        .helperGet("contract-info?contract_id=" + self.contractId)
        .then((r) => {
          console.log("r", r);
          self.form = r.data.data;

          self.front_show = {
            contract_number: self.formatPrice(r.data.data.contract_number),
            amount: self.formatPrice(r.data.data.amount),
            mortgage_price: self.formatPrice(r.data.data.mortgage_price),
            rent_price: self.formatPrice(r.data.data.rent_price),
            first_user_commission: self.formatPrice(
              r.data.data.first_user_commission
            ),
            second_user_commission: self.formatPrice(
              r.data.data.second_user_commission
            ),
          };
          self.dataLoaded = true;
        });
    },
    checkvalidation() {
      let text = "";
      let status = false;
      if (this.form.title.trim() === "") {
        text = "عنوان اجباری می باشد";
        status = true;
      } else if (this.form.contract_date.trim() === "") {
        text = "تاریخ اجباری می باشد";
        status = true;
      } else if (this.form.contract_number.trim() === "") {
        text = "شماره قرارداد اجباری می باشد";
        status = true;
      } else if (this.form.first_users === "0") {
        text = "مشخصات طرف اول اجباری می باشد";
        status = true;
      } else if (this.form.second_users === "0") {
        text = "مشخصات طرف دوم اجباری می باشد";
        status = true;
      } else if (this.form.post_id === "") {
        text = "ملک اجباری می باشد";
        status = true;
      }

      if (status) {
        toast(text, {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      }
      return true;
    },
    setformatPrice(event, param) {
      this.front_show[param] = this.formatPrice(
        event.target.value.replace(/[^\d.-]/g, "")
      );
      this.form[param] = event.target.value.replace(/[^\d.-]/g, "");
    },
    load_consultant() {
      this.helperPost("branch-users-list", { role: "consultant" }).then((r) => {
        this.consultant_list = r.data.list;
      });
    },
    load_users() {
      this.helperPost("branch-users-list", { role: "customer" }).then((r) => {
        this.users_list = r.data.list;
      });
    },
    load_post() {
      this.fillter.branch_id = this.BranchInfos.id;
      if (
        this.$store.state.auth.role == "branch_admin" ||
        this.$store.state.auth.role == "consultant"
      ) {
        const bInfo = JSON.parse(localStorage.getItem("branchinof"));
        this.fillter.branch_id = bInfo ? bInfo.id : null;
        this.fillter.user_id = this.$store.state.auth.uid;
      }
      this.helperPost("post-list", this.fillter).then((r) => {
        if (r.data.result == 0) {
          this.post_list = [];
        } else {
          this.post_list = r.data.data.list;
        }
      });
    },
    save() {
      const validation = this.checkvalidation();
      if (!validation) {
        console.log("validation");
        return;
      }
      this.btnLoading = true;
      if (this.$store.state.auth.role == "consultant") {
        this.form.consultant_id = this.$store.state.auth.uid;
      }
      // const formData = new FormData(document.querySelector("form"));
      this.helperPost("contract-update", this.form)
        .then((r) => {
          if (r.data.success == "1") {
            toast(r.data.msg, {
              type: "success",
              dangerouslyHTMLString: true,
            });
            this.btnLoading = false;
            // this.form = {
            //   cat_id: 2,
            //   title: "",
            //   post_id: "",
            //   first_user_commission: "",
            //   second_user_commission: "",
            //   contract_date: "",
            //   contract_number: "",
            //   amount: "",
            //   consultant_id: "",
            //   first_users: "",
            //   second_users: "",
            //   description: "",
            //   mortgage_price: "",
            //   rent_price: "",
            //   end_date: "",
            // };
            // this.front_show = {
            //   contract_number: "",
            //   amount: "",
            //   mortgage_price: "",
            //   rent_price: "",
            //   first_user_commission: "",
            //   second_user_commission: "",
            // };
          } else {
            toast(r.data.msg, {
              type: "error",
              dangerouslyHTMLString: true,
            });
            this.btnLoading = false;
          }
        })
        .catch(() => {
          toast("دوباره تلاش کنید", {
            type: "error",
            dangerouslyHTMLString: true,
          });
          this.btnLoading = false;
        });
      if (this.noteBookContract) {
        this.closeBtn(true);
      }
    },
    inputFocusHanlder(inputName) {
      this.isFocus = inputName;
    },
    closeBtnPush() {
      document.body.style = "overflow: auto;";
      this.$router.push({ path: "/" });
    },
    closeBtn(reload = false) {
      if (this.noteBookContract) {
        this.$emit("close", { type: "edit", reload });
      } else {
        this.$emit("close");
      }
      document.body.style = "overflow: auto;";
      //   this.clearform();
    },
  },
};
</script>

<style lang="scss" scoped>
.TopShowBackToPage {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  margin: auto;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 5%;
  padding-top: 0px;
  padding-bottom: 0px;
  background: #f5f5f5;
  padding-top: 20px;
  padding-bottom: 10px;
  z-index: 500;
}

.ShowIconVsIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 70px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  cursor: pointer;

  i {
    font-size: 22px;
  }
}

.formTabToggle {
  margin: 22px auto;
  width: 90%;

  .tabToggleContainer {
    position: relative;
    width: 100%;
    max-width: 680px;
    height: 48px;
    border-radius: 12px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #0096c7;
    overflow: hidden;

    &.lease {
      .switchBtn {
        right: 0;
      }
    }

    &.allegiance {
      .switchBtn {
        right: 50%;
      }
    }

    .switchBtn {
      position: absolute;
      bottom: 0;
      width: 50%;
      height: 100%;
      background: #0096c7;
      z-index: 1;
      transition: all 0.15s;
    }

    .tabToggleBtn {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      width: 50%;
      height: 100%;
      background: transparent;
      color: #000;
      font-family: "iranyekan", sans-serif;
      font-size: 14px;
      border-radius: 6px;
      transition: all 0.15s;
      cursor: pointer;
      z-index: 2;

      &.active {
        color: #fff;
      }
    }
  }
}

.createContract {
  min-height: 100vh;
  padding: 88px 32px 24px;

  .createContractFormOuter {
    background: #fff;
    border-radius: 8px;
    padding: 24px 0;
    border-radius: 8px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px -1px rgba(0, 0, 0, 0.1);
  }

  .createContractTitleWrapper {
    position: static !important;
    display: block;
    padding: 0;
    width: 100%;
    height: 70px;
    background: #fff;
    margin-bottom: 16px;

    .contractTitleContainer {
      position: relative;
      width: 90%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;

      .contractTitle {
        font-family: "yekan", sans-serif;
        font-size: 1.6rem;
        font-weight: 600;
      }
    }
  }
}

.createContractForm {
  width: 92%;
  margin: 0 auto;
  overflow-y: auto;
  .createContractFormContainer {
    .createContractFormRow {
      display: flex;
      flex-wrap: wrap;
      margin: 12px 0;

      .contractText {
        padding: 0 16px;
        .formGroupLabel {
          display: block;
          font-size: 14px;
          margin-bottom: 8px;
        }
      }

      .createContractFormGroup {
        position: relative;
        width: 100%;
        background: #fff;
        border-radius: 6px;
        margin-bottom: 38px;
        padding: 0 16px;

        &.focus {
          .formGroupLabel {
            width: auto;
            top: 0;
            padding: 0 6px;
            font-size: 14px !important;
            color: rgb(0, 150, 199) !important;
            background: #fff;
          }

          .textareaLabel {
            width: auto;
            top: -16px;
            font-size: 14px !important;
            color: rgb(0, 150, 199) !important;
            background: #fff;
          }

          .formGroupInput,
          .formGroupTextarea,
          :deep(.formGroupSelect .el-select__wrapper),
          :deep(.pdp-group .formGroupInput) {
            background: #fff !important;
            border: 1px solid #0096c7 !important;
          }
        }

        &.done {
          .formGroupLabel {
            width: auto;
            top: 0;
            padding: 0 6px;
            font-size: 12px;
            color: #000;
            background: #fff;
          }

          .textareaLabel {
            width: auto;
            top: -16px;
            font-size: 12px;
            color: #000;
            background: #fff;
          }

          .formGroupInput,
          .formGroupTextarea,
          :deep(.formGroupSelect .el-select__wrapper),
          :deep(.pdp-group .formGroupInput) {
            background: #fff !important;
            border: 1px solid #ddd;
          }
        }

        .textareaLabel {
          font-family: "iranyekanB", sans-serif;
          position: absolute;
          top: 12px;
          right: 24px;
          padding: 0 6px;
          background: #fff;
          margin: 0;
          font-size: 12px;
          transition: all 0.15s ease-in-out;
          pointer-events: none;
          z-index: 2;
        }

        .formGroupLabel {
          font-family: "iranyekanB", sans-serif;
          position: absolute;
          top: 50%;
          right: 24px;
          transform: translateY(-50%);
          padding: 0 12px;
          background: #fff;
          margin: 0;
          font-size: 12px;
          transition: all 0.15s ease-in-out;
          pointer-events: none;
          z-index: 2;
        }

        .formGroupInput,
        :deep(.formGroupSelect .el-select__wrapper),
        :deep(.pdp-group .formGroupInput) {
          position: relative;
          width: 100%;
          height: 50.4px !important;
          padding: 12px;
          font-size: 14px !important;
          transition: all 0.15s ease-in-out;
          z-index: 1;
          border-radius: 12px;
          border: 1px solid rgb(209, 213, 219);
          background: #fff !important;
          box-shadow: 0 1px 2px 0 rgb(0, 0, 0, 0.1);
        }

        .formGroupTextarea {
          position: relative;
          width: 100%;
          padding: 12px;
          font-size: 14px !important;
          transition: all 0.15s ease-in-out;
          z-index: 1;
          border-radius: 12px;
          border: 1px solid rgb(209, 213, 219);
          background: #fff !important;
          box-shadow: 0 1px 2px 0 rgb(0, 0, 0, 0.1);
          resize: none;

          &:focus {
            outline: none;
          }
        }

        &.fullGroup {
          flex: 0 0 100%;
          max-width: 100%;
        }

        &.oneHalfGroup {
          flex: 0 0 50%;
          max-width: 50%;
        }

        &.oneLessHalfGroup {
          flex: 0 0 41.66667%;
          max-width: 41.66667%;
        }

        &.oneThirdGroup {
          flex: 0 0 33.333333%;
          max-width: 33.333333%;
        }

        &.oneFourthGroup {
          flex: 0 0 25%;
          max-width: 25%;
        }

        &.oneSixthGroup {
          flex: 0 0 16.66667%;
          max-width: 16.66667%;
        }
      }

      .contractText {
        width: 100%;
      }
    }
  }
}

.formButtonContainer {
  width: 92%;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin: 32px auto 24px;
  padding-bottom: 24px;

  .formSubmitBtn {
    position: relative;
    width: 150px;
    height: 45px;
    border-radius: 12px;
    background: #0096c7;
    text-align: center;
    color: #fff;
    cursor: pointer;
    font-size: 0.9rem;
    font-family: "iranyekanB";
    transition: 0.1s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &.closeBtn {
      background: #d90429;

      &:hover {
        background: #97031c;
      }
    }

    &:hover {
      background: #023e8a;
    }
  }
}
.text-danger {
  color: #ef2323;
  font-size: 14px;
}

@media (max-width: 992px) {
  .createContractForm {
    .createContractFormContainer {
      .createContractFormRow {
        &:not(:first-of-type) {
          .createContractFormGroup {
            flex: 0 0 100%;
            max-width: 100%;
          }
        }
      }
    }
  }
}

@media (max-width: 868px) {
  .createContractForm {
    .createContractFormContainer {
      .createContractFormRow {
        .createContractFormGroup {
          flex: 0 0 100% !important;
          max-width: 100% !important;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .createContract {
    margin: 0;
    width: 100%;
    padding: 64px 0 0;

    .createContractFormOuter {
      width: 100%;
      margin: 0 auto;
      border-radius: 0;
      box-shadow: none;
    }
  }

  .createContractForm {
    .createContractFormContainer {
      .createContractFormRow {
        .contractText {
          padding: 0;
        }
        .createContractFormGroup {
          flex: 0 0 100% !important;
          max-width: 100% !important;
          padding: 0;
          margin-bottom: 24px !important;

          .formGroupLabel,
          .textareaLabel {
            right: 12px;
          }

          :deep(.formGroupSelect .el-select__wrapper) {
            width: 99%;
          }
        }
      }
    }
  }
}
.loader {
  width: 25px !important;
  height: 25px !important;
  margin-bottom: 5px;
}
</style>
